import React from 'react'

function Footer({ pageIndex, totalPages }) {
  return (
    <div style={{ pageBreakAfter: pageIndex === totalPages ? 'avoid' : 'always'}}>
    </div>
  )
}

export default Footer